<div class="ui-key">
    @if (mouse) {
        <div class="ui-key__mouse">
            <div class="ui-key__mouse-left" [class.active]="mouse === 'left'"></div>
            <div class="ui-key__mouse-right" [class.active]="mouse === 'right'"></div>
            <div class="ui-key__mouse-wheel" [class.active]="mouse === 'middle'"></div>
        </div>
    } @else {
        {{ key }}
    }
</div>
